import React, { useState } from 'react';
import { authApi } from '../services/api';

function LoginForm({ onLoginSuccess, onClose, onSwitchToRegister }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('请输入邮箱和密码');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const response = await authApi.login(email, password);
      
      if (response.success) {
        // 登录成功，保存token并通知父组件
        localStorage.setItem('token', response.data.token);
        onLoginSuccess(response.data.user);
      } else {
        setError(response.error || '登录失败，请检查账号或密码');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('登录失败，请稍后再试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-form">
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            id="email"
            placeholder="邮箱"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        
        <div className="form-group">
          <input
            type="password"
            id="password"
            placeholder="密码"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>
        
        <button 
          type="submit" 
          id="loginSubmit"
          disabled={loading}
        >
          {loading ? '登录中...' : '登录'}
        </button>
      </form>
      
      <div className="form-footer">
        <p className="form-switch">
          没有账号？<a href="#" onClick={(e) => { e.preventDefault(); onSwitchToRegister(); }}>立即注册</a>
        </p>
      </div>
    </div>
  );
}

export default LoginForm;